// Locale helpers shared by every Stimulus controller that formats dates, times
// or numbers client-side. The page locale is whatever the Rails layout stamped
// on <html lang>, so a new locale needs no change here — only SPEECH_LOCALE and
// TIMER_UNIT below name locales explicitly.

// BCP-47 tags for speech recognition (Web Speech API and SFSpeechRecognizer).
// Add an entry when a new locale ships.
const SPEECH_LOCALE = { en: "en-US", ar: "ar-SA", de: "de-DE", nl: "nl-NL", sv: "sv-SE", da: "da-DK", fr: "fr-FR", nb: "nb-NO", fi: "fi-FI", it: "it-IT", es: "es-ES", sk: "sk-SK", sl: "sl-SI" }

// Second abbreviation used by the recording countdown. Falls back to "s".
const TIMER_UNIT = { ar: " ث" }

// The locale Rails rendered the page in, e.g. "en", "ar", "de", "nl", "sv".
function pageLocale() {
  return document.documentElement.lang || "en"
}

// A tag Intl accepts. Passing the page locale straight through means any locale
// Rails ships formats correctly without a per-locale branch.
export function intlLocale() {
  return pageLocale()
}

export function speechLocale() {
  const lang = pageLocale()
  return SPEECH_LOCALE[lang] ?? lang
}

export function timerUnit() {
  return TIMER_UNIT[pageLocale()] ?? "s"
}
